/**
 * Frontend-only presentation config for the three Pulse Insights tracks.
 * The API returns `track_slug` + `title`; colour, icon and the gauge caption
 * are mapped here by slug because they are pure branding, not data.
 */
const INTRO_PREFIX = "Please answer the following questions honestly - your answers are confidential, and we use them to help us understand how to support you with";
export const PULSE_TRACK_THEMES = {
    pulse_well_in_mind: {
        key: "mind",
        color: "#2f9e57",
        image: "/img/insightsv2/well_in_mind.png",
        scoreLabel: "Mind Score",
        shortLabel: "Mind",
        defaultTitle: "Well in Mind",
        description: `${INTRO_PREFIX} better mental health.`,
    },
    pulse_well_in_body: {
        key: "body",
        color: "#3b6fe8",
        image: "/img/insightsv2/well_in_body.png",
        scoreLabel: "Body Score",
        shortLabel: "Body",
        defaultTitle: "Well in Body",
        description: `${INTRO_PREFIX} better physical health.`,
    },
    pulse_well_in_life: {
        key: "life",
        color: "#8b46d6",
        image: "/img/insightsv2/well_in_life.png",
        scoreLabel: "Life Score",
        shortLabel: "Life",
        defaultTitle: "Well in Life",
        description: `${INTRO_PREFIX} better lifestyle choices.`,
    },
};
export const DEFAULT_PULSE_TRACK_THEME = {
    key: "track",
    color: "#6c757d",
    image: "/img/insightsv2/well_in_mind.png",
    scoreLabel: "Score",
    shortLabel: "Score",
    defaultTitle: "Wellbeing",
    description: `${INTRO_PREFIX} your wellbeing.`,
};
export const PULSE_BAND_STYLES = {
    thriving: { color: "#16a34a", background: "#dcfce7" },
    moderate: { color: "#d97706", background: "#fef3c7" },
    low: { color: "#ea580c", background: "#ffedd5" },
    critical: { color: "#dc2626", background: "#fee2e2" },
};
export const DEFAULT_PULSE_BAND_STYLE = {
    color: "#6b7280",
    background: "#f1f3f6",
};
export const getPulseBandStyle = (bandSlug) => (bandSlug && PULSE_BAND_STYLES[bandSlug]) || DEFAULT_PULSE_BAND_STYLE;
/** Map an EAP phone country code to a friendly label (e.g. "IE" -> "Ireland"). */
export const PULSE_PHONE_COUNTRY_LABELS = {
    IE: "Ireland",
    UK: "United Kingdom",
    GB: "United Kingdom",
    NI: "Northern Ireland",
};
export const getPulseTrackTheme = (slug) => PULSE_TRACK_THEMES[slug] ?? DEFAULT_PULSE_TRACK_THEME;
/** Convert a `#rrggbb` colour into an `rgba()` string at the given alpha. */
export const hexToRgba = (hex, alpha) => {
    const normalised = hex.replace("#", "");
    const red = parseInt(normalised.substring(0, 2), 16);
    const green = parseInt(normalised.substring(2, 4), 16);
    const blue = parseInt(normalised.substring(4, 6), 16);
    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};
